import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import download from "../../assets/Images/icons8-download-24.png";
import loader from "../../assets/Images/loader.gif";
import { click } from "@testing-library/user-event/dist/click";
import imageCompression from "browser-image-compression";
import { toast } from "react-toastify";

export default function BusinessCAFmanageFormDOC() {
  const [loading, setLoading] = useState(true);
  const [activeForm, setActiveForm] = useState("form1");
  const [documentfile, setDocumentfile] = useState("");
  const [attachedFile, setAttachedFile] = useState([]); // Store uploaded files
  const [customerDetails, setCustomerDetails] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [paymentMethod, setPaymentMethod] = useState("");
  const [fileName, setFileName] = useState([]); // Store file names
  // const [attachmentName,setAttachmentName]= useState('');
  // const [documents, setDocuments] = useState([]);
  // const [Base64Images,setBase64Images]= useState([]);
  const [base64Strings, setBase64Strings] = useState([]); // Store base64
  const [statusNoCaf, setStatusNoCaf] = useState(true);
  const [statusCaf, setStatusCaf] = useState(true);
  const [disableFileds, setDisableFields] = useState(false);
  const [disableRemark, setDisableRemark] = useState(false);
  const [remark ,setRemark]= useState();
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const CafId = searchParams.get("CafId");

  const handleIconClick = () => {
    // console.log("cafid", CafId);

    // Navigate to the desired URL
    // alert('2')
    navigate(`/BusinessCAFmanageFormDOC?CafId=${CafId}`);
  };

  const redirectBusinessCafformPage = () => {
    navigate(`/businessCAFmanageForm?CafId=${CafId}`);
  };

  // Use useEffect to set the active form after navigation
  useEffect(() => {
    if (location.pathname === "/BusinessCAFmanageFormDOC") {
      setActiveForm("form8");
      handleIconClick();
    } else {
      setActiveForm(null);
    }
  }, [location.pathname, CafId]);
  const [checkboxes, setCheckboxes] = useState({
    TanNo: false,
    TinNo: false,
    CafNo: false,
    PurchaseOrder: false,
    Apnic: false,
    PhotoId: false,
    OspDeclaration: false,
    NtwDiagram: false,
    AddressProofCom: false,
    PanCard: false,
    check11: false,
    check12: false,
  });
  const handleCheckboxChange = (checkboxId) => {
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [checkboxId]: !prevCheckboxes[checkboxId],
    }));
    // console.log("check", checkboxId);
  };

  // console.log("attachedFile", base64Strings)
  // console.log("check",checkboxes.check10)
  // console.log("fileName",attachedFile)


  const handleRemark  = (e) =>{
    setRemark(e.target.value)
  }
  const handleDocumentSave = async (base64, fileName) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    const requestData = {
      Action: "updateDocument",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      cafNo: CafId,
      // "cafNo": "CAF_113258",
      companyId: "",
      documentRequired: {
        addressProof: checkboxes.AddressProofCom,
        apnic: checkboxes.Apnic,
        cafNo: checkboxes.CafNo,
        childIDNew: true,
        coiAndPan: false,
        documentData: [
          {
            fileContent: base64, // Only take the first base64 string
            fileNameWithExtension: fileName, // Only take the name of the first attached file
          },
        ],
        industryType: "",
        listOfBoardofDirectors: "",
        networkDiagram: checkboxes.NtwDiagram,
        nonOSPdeclaratrion: checkboxes.OspDeclaration,
        panCardNo: checkboxes.PanCard,
        parentIDNew: false,
        photoIdProofofAuthSign: checkboxes.PhotoId,
        poLock: "",
        poNext: "",
        purchaseOrderpo: "",
        tanno: checkboxes.TanNo,
        tinNo: checkboxes.TinNo,
      },
      groupId: "",
      iscustomerimage: checkboxes.check12,
      relationshipId: "",
      safNo: "",
      password: sessionStorage.getItem("password"),
      userName: sessionStorage.getItem("userName"),
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    // console.log("API Response update DOCS2213213:", result);


    if (result.Status === "Success"){
      // console.log("sucnc");
      toast.success("Document Updated Successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
    });
   
    }






    
    
  };

  {
    /* ***********for getDocument data API ********* */
  }
  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          Action: "getDocument",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          cafNo: CafId,
          oppid: "O-12-2023-138250",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
          safNo: "",
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        // console.log("API Response DOCS:", result);
        setDocumentfile(result.Response.attachDocs);
        setRemark(result.Response.Data.Remark)
        // console.log(
        //   "API Response DOCS:",
        //   result.Response.Data.accordingtoFirmType
        // );

        // setCheckboxes(result.Response.Data.accordingtoFirmType)
        // Extract and set checkboxes data
        const checkboxData = result.Response.Data.accordingtoFirmType;
        setCheckboxes((prevCheckboxes) => ({
          ...prevCheckboxes,
          TanNo: checkboxData.TanNo === "1",
          TinNo: checkboxData.TinNo === "1",
          CafNo: checkboxData.CafNo === "1",
          PurchaseOrder: checkboxData.PurchaseOrder === "1",
          Apnic: checkboxData.Apnic === "1",
          PhotoId: checkboxData.PhotoId === "1",
          OspDeclaration: checkboxData.OspDeclaration === "1",
          NtwDiagram: checkboxData.NtwDiagram === "1",
          AddressProofCom: checkboxData.AddressProofCom === "1",
          PanCard: checkboxData.PanCard === "1",
          Coi: checkboxData.Coi === "1",
          Lco: checkboxData.Lco === "1",
          ListDirector: checkboxData.ListDirector === "1",
          Memorendum: checkboxData.Memorendum === "1",
          PropAddressProof: checkboxData.PropAddressProof === "1",
        }));
        setLoading(false);
        // console.log("result.Response.attachDocs", result.Response.attachDocs);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    fetchDocument();
  }, []);

  {
    /* ***********for getCaf data API ********* */
  }
  useEffect(() => {
    const fetchBussinessCAF = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          Action: "getCaf",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          cafNo: CafId,

          oppid: "",
          password: "Spectra@1704$",
          userName: "salesperson1",
          safNo: "",
          //   password: 'Target@2021#@',
          //   userName: 'manager1',
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        // console.log("API Response caf:", result);
        if (response.status === 200) {
          // alert('101')
          if (
            !result.Response.Data.CafNo ||
            result.Response.Data.CafNo === ""
          ) {
            // console.log("caf:", result.Response.Data.CafNo);
            setStatusNoCaf(true);
            setStatusCaf(false);
          } else {
            // alert('102')
            setCustomerDetails(result.Response.Data);
            setPaymentDetails(result.Response.Data.payments);
            setPaymentMethod(result.Response.Data.payments.PayInSlip);
            setStatusNoCaf(false);
            setStatusCaf(true);
            setDisableFields(false);
            setDisableRemark(true);
          }
        } else {
          // alert('103')
          setCustomerDetails(result.Response.Data);
          // console.log("customerDetails.Company", customerDetails.Company);
          const bussinessSegment = result.Response.Data.BusinessSegment;

          setPaymentDetails(result.Response.Data.payments);
          setPaymentMethod(result.Response.Data.payments.PayInSlip);
          // console.log("paty", result.Response.Data.payments.PayInSlip);
          // console.log("wqeqw", result.Response.Data);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    fetchBussinessCAF();
  }, []);

  const handleFileUpload = async (event) => {
    // alert('hloo')
    // Get the first selected file
    const selectedFile = event.target.files[0];
    // Set compression options
    const options = {
      maxSizeMB: 1, // Maximum file size in MB
      maxWidthOrHeight: 1920, // Max width or height
      useWebWorker: true, // Use web worker for faster compression
    };
    // Compress the image file
    const compressedFile = await imageCompression(selectedFile, options);
    // Update state with selected file
    // console.log("selectedFile.name", selectedFile.name);
    setAttachedFile(selectedFile.name);

    // Read the file as a data URL and handle the base64 string
    const reader = new FileReader();
    reader.onloadend = async () => {
      // Handle base64 string
      let base64String = reader.result;

      // Check if the base64 string exists
      if (base64String) {
        // Remove the prefix "data:image/png;base64," if it exists
        const prefixIndex = base64String.indexOf(";base64,");
        if (prefixIndex !== -1) {
          base64String = base64String.slice(prefixIndex + 8); // +8 to remove the prefix including ";base64,"
        }

        // Remove quotes from the beginning and end of the string, if present
        base64String = base64String.replace(/^"|"$/g, "");
        // console.log("base64", base64String);
        // Update base64Strings state with the single base64 string
        setBase64Strings(base64String);

        // Call handleDocumentSave API after handling file upload
        await handleDocumentSave(base64String, selectedFile.name);
      } else {
        // console.log("Base64 string is empty or undefined");
      }
    };

    reader.readAsDataURL(compressedFile);
    // console.log("fileuploaded", [selectedFile.name]);
    // Update state with file name
    setFileName([selectedFile.name]);
  };

  const handleIconuPLOClick = () => {
    // alert('232')
    fileInputRef.current.click();
  };

  const handleDownload = (fileName, base64String) => {
    try {
      // console.log("Downloading file:", fileName, base64String); // Add logging here

      if (
        !base64String ||
        typeof base64String !== "string" ||
        !isValidBase64(base64String)
      ) {
        throw new Error(
          "Base64 string is missing, invalid, or not properly encoded."
        );
      }

      // Create blob from base64 string
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray]);

      // Create download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;

      // Append link to the body, trigger download, and remove link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const isValidBase64 = (base64String) => {
    // Regular expression to check if the string is valid base64
    const base64Regex = /^[a-zA-Z0-9+/]*={0,2}$/;
    return base64Regex.test(base64String);
  };

  function getAbbreviatedName(fileName) {
    const maxLength = 15; // Maximum length of the abbreviated name
    if (fileName.length <= maxLength) {
      return fileName; // Return the original name if it's already short
    } else {
      // Abbreviate the name and add ellipsis at the end
      return fileName.slice(0, maxLength - 3) + "...";
    }
  }

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectBusinessCafformPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">CAF</span>
          {/* {!statusNoCaf && (
                    <button type="download" className="btn text-dark  mx-auto cstm-handler" onClick={handleDownloadReport}>
                        <i className="fa-solid fa-download"></i> Download
                    </button>
                    )} */}
        </div>
      </div>

      {/* ***********Header END********* */}
      <div>
        {loading && (
          <div className="loader-wrapper">
            <div className="loader">
              <img src={loader} alt="loading...."></img>
            </div>
          </div>
        )}
        <div
          className="documentdetails-toggle mt-3"
          onClick={() => handleIconClick("form8")}
        >
          <span className="toggle-text">Document</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form8" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-5"
            id="form8"
          >
            {/* *********Document Details form******** */}
            <form className="contact-form p-2">
              <div
                className="input-box form-floating"
                style={{ position: "relative" ,paddingTop:"3px"}}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="fullName"
                  name="fullName"
                  value={customerDetails.CafNo}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="lock">
                  CAF No.*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative",paddingTop:"3px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  value={paymentDetails.Account}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="lock">
                  Account*
                </label>
              </div>

              <div className="p-3">

              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="TanNo"
                  checked={checkboxes.TanNo}
                  onChange={() => handleCheckboxChange("TanNo")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="TanNo">
                  TAN No.*
                </label>
              </div>

              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="TinNo"
                  checked={checkboxes.TinNo}
                  onChange={() => handleCheckboxChange("TinNo")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="TinNo">
                  {" "}
                  TIN No.(Hardware Sale)*
                </label>
              </div>

              <div className="x-cstmz ">
                <input
                  type="checkbox"
                  id="CafNo"
                  checked={checkboxes.CafNo}
                  onChange={() => handleCheckboxChange("CafNo")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="CafNo">
                  {" "}
                  CAF*
                </label>
              </div>

              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="PurchaseOrder"
                  checked={checkboxes.PurchaseOrder}
                  onChange={() => handleCheckboxChange("PurchaseOrder")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="PurchaseOrder">
                  Purchase Order(P.O)*
                </label>
              </div>
              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="Apnic"
                  checked={checkboxes.Apnic}
                  onChange={() => handleCheckboxChange("Apnic")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="Apnic">
                  APNIC(Public IP Declaration form)*
                </label>
              </div>
              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="PhotoId"
                  checked={checkboxes.PhotoId}
                  onChange={() => handleCheckboxChange("PhotoId")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="PhotoId">
                  Photo ID proof of Authorized Signatory*
                </label>
              </div>
              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="OspDeclaration"
                  checked={checkboxes.OspDeclaration}
                  onChange={() => handleCheckboxChange("OspDeclaration")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="OspDeclaration">
                  Non OSP Declaration/OSP Registration Certificate
                </label>
              </div>
              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="NtwDiagram"
                  checked={checkboxes.NtwDiagram}
                  onChange={() => handleCheckboxChange("NtwDiagram")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="NtwDiagram">
                  {" "}
                  Network Diagram*
                </label>
              </div>
              <div className="x-cstmz ">
                <input
                  type="checkbox"
                  id="AddressProofCom"
                  checked={checkboxes.AddressProofCom}
                  onChange={() => handleCheckboxChange("AddressProofCom")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="AddressProofCom">
                  {" "}
                  Address Proof oF Company/Firm*
                </label>
              </div>
              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="check10"
                  checked={checkboxes.PanCard}
                  onChange={() => handleCheckboxChange("check10")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="check10">
                  Company's PAN Card copy*
                </label>
              </div>
              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="check11"
                  checked={checkboxes.check11}
                  onChange={() => handleCheckboxChange("check11")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="check11">
                  {" "}
                  Partnership Deed*
                </label>
              </div>
              <div className="x-cstmz">
                <input
                  type="checkbox"
                  id="check12"
                  checked={checkboxes.check12}
                  onChange={() => handleCheckboxChange("check12")}
                  disabled={disableFileds}
                />
                <label className="y-cstmz" htmlFor="check12">
                  {" "}
                  Customer Live Photo*
                </label>
              </div>
              </div>

              {/* <div className="input-group mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Choose the file ..."
                                />
                                <label
                                    className="input-group-text"
                                    htmlFor="fileInput"
                                    style={{ cursor: 'pointer' }}
                                    onClick={handleAttachClick}
                                >
                                    <i className="fas fa-paperclip"></i>
                                </label>
                                <input
                                    type="file"
                                    className="d-none"
                                    id="fileInput"
                                    name="fileInput"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                />
                            </div> */}

              <div>
                <div
                  className="cstm-docart"
                  style={{ cursor: "pointer", marginBottom: "10px" }}
                  onClick={handleIconuPLOClick}
                >
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Click here"
                      className="form-control input-text form-control-sm"
                      id="firstName"
                      name="firstName"
                      // value={authresidentadd}
                      // onChange={handleAuthResidentailADD}
                      disabled={disableFileds}
                    />
                    
                    <i className="fas fa-paperclip cstm-hand" style={{ position: 'absolute', top: '70%', right: '20px', transform: 'translateY(-50%)', cursor: 'pointer' }}></i>
                    <label className=" mt-1  ">
                      Attach File
                    </label>
                  </div>
                  <input
                    type="file"
                    className="d-none"
                    accept="image/jpeg, image/png, message/rfc822"
                    onChange={handleFileUpload}
                    ref={fileInputRef}
                    disabled={disableFileds}
                    multiple // Allow multiple file selection
                    
                  />
                </div>
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm"
                    id="firstName"
                    name="firstName"
                    disabled={disableRemark}
                    value = {remark}
                    onChange={handleRemark}
                    style={{backgroundColor:"transparent"}}
                  />
                  <label className="mt-1">Remark</label>
                </div>
                {fileName.length > 0 && (
                  <div className="view-documents cstm-hand2 p-2">
                    <h6>Uploaded Now:</h6>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>File Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fileName.map((fileName, index) => (
                          <tr key={index}>
                            <td>{getAbbreviatedName(fileName)}</td>
                            <td>
                              <button
                                type="button"
                                className="btn "
                                onClick={() =>
                                  handleDownload(fileName, base64Strings)
                                }
                              >
                                <i className="fa-solid fa-arrow-down"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {documentfile &&
                  Array.isArray(documentfile) &&
                  documentfile.length > 0 && (
                    <div className="view-documents cstm-hand2 p-2">
                      <h6>View Documents:</h6>
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>File Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {documentfile.map((document, index) => (
                            <tr key={index}>
                              <td>{document.Filename}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={() =>
                                    handleDownload(
                                      document.Filename,
                                      document.Attachment
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-arrow-down"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>

              
            </form>
          </div>
        )}

        <div className=" text-center mt-5 mb-5">
                <button
                  type="button"
                  className="btn text-light  bg-dark mx-auto submit-btn rounded-pill"
                  onClick={handleDocumentSave}
                >
                  Save Document
                </button>
              </div>
      </div>
    </>
  );
}
